<div style="display: flex;height: 100%; justify-content: center;align-items: center;" class="row">
        <div class="col-md-8 col-md-offset-2">
            <h1 style="padding-top: 10px;text-align: center;" class="text-center">
                Thank you for your interest,<br> but unfortunately, you do not meet the qualifications for any additional surveys at this time.</h1>
            <div style="height: 1px" id="pixelImg"></div>
        </div>
    </div>